import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteUser, fetchUserList } from './actions';
import { setErrorToastState } from 'Store/action';
import { set_delete_user_dialog, set_user_details_drawer } from 'Store/reducers/adminReducer';
import { set_users, set_user_details } from 'Store/reducers/userReducer';
import { AppDispatch, RootState } from 'Store/Store';
import Popup from 'Components/Popup/Popup';

export const DeleteUser: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const delete_user_dialog = useSelector((state: RootState) => state?.admin?.delete_user_dialog);
  const user_details = useSelector((state: RootState) => state?.user?.user_details);
  const [loading, setLoading] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState('');

  const handleDeleteUser = (confirm: boolean) => {
    setServerErrorMessage('');
    if (confirm) {
      setLoading(true);
      return deleteUser(user_details?.id || '')
        .then(res => {
          if (res.status === 200) {
            fetchUserList().then(res => {
              if (res.status === 200) {
                dispatch(set_users(res.data));
              }
            });
            dispatch(set_user_details(null));
            dispatch(set_delete_user_dialog(false));
            dispatch(set_user_details_drawer(false));
          }
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          dispatch(setErrorToastState(true, 'Something went wrong, please try again in a while.'));
          setServerErrorMessage(err?.response?.data?.message);
        });
    } else {
      dispatch(set_delete_user_dialog(false));
    }
  };

  return (
    <Popup
      title="Delete User?"
      open={delete_user_dialog}
      dialogContent="Are you sure you want to delete this user? This action is not reversible."
      serverErrorMessage={serverErrorMessage}
      loading={loading}
      acceptButtonTitle="Delete"
      handleAcceptOnClick={() => handleDeleteUser(true)}
      rejectButtonTitle="Cancel"
      handleRejectOnClick={() => handleDeleteUser(false)}
    />
  );
};

export default DeleteUser;
